import React from 'react';
import T from 'prop-types';
import { intersection, filter } from 'lodash-es';

import DateRange from './DateRange';
import SearchEntities from './SearchEntities';
import ExportSettings from './ExportSettings';
import PanelVersionDropdown from './PanelVersionDropdown';
import DataTypeSwitcher from '../DataTypeSwitcher';
import Container from '../../../Container';

import { ADVANCED_METRICS_V2_MAP, COHORTS_BY_PANEL, PANEL_ALLOWED_COUNTRIES, CROSS_APP_PANEL_VERSION_MAPPING, AI_COHORTS_SHORT_NAMES } from '../../../../utils/advanced-metrics';
import { DATA_TYPE } from '../../configs/constants';
import { notAllowMetricFor } from '../../configs/report';
import { unifiedRefNoBy } from '../../../../utils/helpers';

const UpsertExportForm = ({
  initParams = {},
  formMode,
  dataType,
  report = {},
  autoFocus,
  formActions,
  prefetchingEntities,
  onReset,
  onPrefill,
  onChange,
  onChangeDataType,
}) => {
  const { permissions } = initParams;

  const handlePanelsVersionChange = (newVersion) => {
    const isNotAiPanel = !['us-blended-v1-r0-0-public'].includes(newVersion);
    let cross_apps_pairs = {}
    if (CROSS_APP_PANEL_VERSION_MAPPING[newVersion]) {
      cross_apps_pairs = report.entities.reduce((acc, entity) => {
        if ((entity.panels || []).includes(CROSS_APP_PANEL_VERSION_MAPPING[newVersion])) {
          const unifiedId = unifiedRefNoBy(entity);
          if (report.cross_apps_pairs[unifiedId]) {
            acc[unifiedId] = report.cross_apps_pairs[unifiedId];
          }
        }
        return acc;
      }, {});
    }
    onChange({
      ...report,
      data_points: intersection(report.data_points, ADVANCED_METRICS_V2_MAP[newVersion]).filter(d => !notAllowMetricFor(newVersion, d)),
      user_segments: filter(intersection(report.user_segments, COHORTS_BY_PANEL[newVersion]), (s) => !(isNotAiPanel && AI_COHORTS_SHORT_NAMES[s])),
      panel_version: newVersion,
      countries_iso: PANEL_ALLOWED_COUNTRIES[newVersion],
      cross_apps_pairs,
    });
  };

  return (
    <section className="upsert-export-form">
      <Container maxWidth={870}>

        {(permissions?.allowAdvancedMetricsExport || permissions?.allowMpi) && (
          <DataTypeSwitcher
            value={dataType}
            dataType={dataType}
            report={report}
            onChange={onChangeDataType}
          />
        )}
        <DateRange
          initParams={initParams}
          dataType={dataType}
          report={report}
          onReportChange={onChange}
        />
        {dataType === DATA_TYPE.ADVANCED && (
          <PanelVersionDropdown
            panelVersion={report.panel_version}
            showOnlyPublicPanels={!permissions.allowPanelsVersionSwitcher}
            allowedDatasets={permissions.advancedDatasets}
            onChange={handlePanelsVersionChange}
          />
        )}
        <SearchEntities
          initParams={initParams}
          formMode={formMode}
          dataType={dataType}
          report={report}
          autoFocus={autoFocus}
          prefetchingEntities={prefetchingEntities}
          onReset={onReset}
          onReportChange={onChange}
        />
        <ExportSettings
          dataType={dataType}
          report={report}
          onReportChange={onChange}
          onPrefill={onPrefill}
        />
        <div className="upsert-export-form__buttons">
          {formActions}
        </div>
      </Container>
    </section>
  );
};

UpsertExportForm.propTypes = {
  initParams: T.object.isRequired,
  formMode: T.object.isRequired,
  dataType: T.string.isRequired,
  report: T.object.isRequired,
  autoFocus: T.bool,
  formActions: T.node,
  prefetchingEntities: T.bool,
  onReset: T.func.isRequired,
  onPrefill: T.func.isRequired,
  onChange: T.func.isRequired,
  onChangeDataType: T.func.isRequired,
};

export default UpsertExportForm;
